import React from 'react'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import { leagueUpdatesStore } from 'state/league/leagueUpdates'
import AddUpdateForm from './ModalContent/AddUpdateForm'

const AddUpdateModal: React.FC = () => {
  const { form, handleSubmit } = useFormSubmit()
  const {
    addUpdateModal,
    setAddUpdateModal,
    editUpdateModal,
    setEditUpdateModal,
    selectedUpdate,
    setSelectedUpdate,
  } = leagueUpdatesStore(store => ({
    addUpdateModal: store.addUpdateModal,
    setAddUpdateModal: store.setAddUpdateModal,
    editUpdateModal: store.editUpdateModal,
    setEditUpdateModal: store.setEditUpdateModal,
    selectedUpdate: store.selectedUpdate,
    setSelectedUpdate: store.setSelectedUpdate,
  }))

  const isOpen = addUpdateModal || editUpdateModal

  const closeModal = () => {
    setSelectedUpdate(null)
    setAddUpdateModal(false)
    setEditUpdateModal(false)
  }

  return (
    <CustomModal
      openModal={isOpen}
      isCloseModalCustom
      closeModal={closeModal}
      title={selectedUpdate ? 'Edit Update' : 'Add Update'}
      footer={
        <CustomModalFooter
          multibutton={false}
          btnAlignment="justify-end"
          btnText={selectedUpdate ? 'Save changes' : 'Publish update'}
          closeModal={closeModal}
          onSubmit={handleSubmit}
        />
      }
    >
      <AddUpdateForm form={form} />
    </CustomModal>
  )
}

export default AddUpdateModal
